import React from 'react';
import { Button, Modal } from 'react-bootstrap';
export const ConfirmationModal = (props) => {
	return (
		<Modal
			{...props}
			aria-labelledby='contained-modal-title-vcenter'
			dialogClassName='modal-md modal-box reviewedit'
			className='confirmation-modal'
			backdrop='static'
			keyboard={false}>			
			<Modal.Header
				closeButton
				className='modal-header border-0'>
					<h4>
					{' '}
					{props.commonJSONText &&
						props.commonJSONText.resetAlert &&
						props.commonJSONText.resetAlert.title}
				</h4>					
				</Modal.Header>
			<Modal.Body>	
				
				<p>
					{' '}
					{props.commonJSONText &&
						props.commonJSONText.resetAlert &&
						props.commonJSONText.resetAlert.info}
				</p>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant='white'
					className='modal-btn'
					closeButton
					onClick={props.onHide}>
					<i class="fas fa-arrow-left"></i>
					{props.commonJSONText &&
						props.commonJSONText.resetAlert &&
						props.commonJSONText.resetAlert.cancelBtn}
				</Button>
				<Button
					variant='white'
					className='modal-btn'
					id="startAgain"
					onClick={() => props.navigateTo('stole-design')}>
					{props.commonJSONText &&
						props.commonJSONText.resetAlert &&
						props.commonJSONText.resetAlert.startAgainBtn}
						&nbsp;&nbsp;	<i class="fas fa-arrow-right"></i>
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
